import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/Marquee";
import { Collections } from "@/components/site/Collections";
import { Manifesto } from "@/components/site/Manifesto";
import { Process } from "@/components/site/Process";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <main data-testid="home-page" className="bg-[#FBF9F6]">
      <Nav />
      <Hero />
      <BrandMarquee />
      <Collections />
      <Manifesto />
      <Process />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
